import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLayers } from '@agissc/ktag-map';
import { Button } from '@ktag/styleguide/dist/react';
import InfoBox from '../../components/infoBox/InfoBox';
import useAppState from '../../AppStore';
import useBasemapCategories from './api/useBasemapCategories';

const BasemapNotFoundNotification = () => {
  const { t } = useTranslation('agisviewer');

  const selectedBasemapId = useAppState((state) => state.selectedBasemapId);
  const setSelectedBasemapCategory = useAppState(
    (state) => state.setSelectedBasemapCategory,
  );

  const [showNotification, setShowNotification] = useState<boolean>(true);

  const { isLoading, data: layers, error } = useLayers();
  const { data: basemapCategories } = useBasemapCategories();

  const isBasemapValid = Boolean(layers && layers[selectedBasemapId]);
  if (isBasemapValid || !showNotification || isLoading || error) return null;

  const handleConfirmClick = () => {
    const defaultItem = basemapCategories?.grayscale.defaultItem;
    if (!defaultItem) return;

    setSelectedBasemapCategory('grayscale', defaultItem);
  };

  return (
    <InfoBox heading={t('info_box_title')} onClose={() => setShowNotification(false)}>
      <p>{t('notification_basemap_invalid')}</p>
      <p>{t('notification_basemap_invalid_description')}</p>
      <Button onClick={handleConfirmClick} additionalClassNames="button__max-width">
        OK
      </Button>
    </InfoBox>
  );
};

export default BasemapNotFoundNotification;
